/*
 * Copyright (c) 2026 Gabriele Bonora. Tutti i diritti riservati.
 *
 * Software proprietario. Nessuna licenza d'uso, copia, modifica o distribuzione
 * e' concessa in assenza di autorizzazione scritta del titolare dei diritti.
 * Vedere il file LICENSE nella radice del progetto.
 */
import apiClient from './client';

export const impostazioniAPI = {
  // Pubblica: serve anche prima dell'accesso, per la schermata di login
  leggi: async () => { const { data } = await apiClient.get('/impostazioni'); return data; },
};
